var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v("Your IP Addresses")]),
          _c(
            "gg-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.hosting_detail.ips
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function fn(_ref) {
                      var item = _ref.item
                      return [
                        _c(
                          "gg-btn",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openEditDialog({
                                  ip: item.ip,
                                  ptr: item.ptr
                                })
                              }
                            }
                          },
                          [_vm._v(" Manage ")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("hosting-edit-ip-addr-form", {
                attrs: {
                  ip_record: _vm.model.ip,
                  ptr_record: _vm.model.ptr,
                  service_id: _vm.model.service_id,
                  "dialog-state": _vm.modal
                },
                on: {
                  close: _vm.closeEditDialog
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }